<div class="usercard" #usercard>
  <div class="avatar">
    <app-avatar
      [name]="firstName + ' ' + lastName"
      [showBadge]="showBadge"
      [identityVerificationStatus]="identityVerificationStatus"
      [workspaces]="workspaces"
      [userId]="userId"
      [width]="40"
      [height]="40"
      [hasImage]="!!profilePic"
      [picUrl]="profilePic"
      [user]="contact"
      [isWorkspaceVerified]="isWorkspaceVerified"
      [isProfessionVerified]="professionVerified"
    >
    </app-avatar>
  </div>
  <div class="texts fw block" #texts>
    @if (profileId === userId) {
      <div class="name celo-elipsis">
        @if (replaceMyName) {
          <span>{{ replaceMyName }}</span>
        }
        @if (!replaceMyName) {
          <span>{{ firstName }} {{ lastName }}</span>
        }
      </div>
    }
    @if (profileId !== userId) {
      <div class="name celo-elipsis">{{ firstName }} {{ lastName }}</div>
    }
    @if (!hideProfession) {
      <div class="subtitle-text">
        @if (profession && professionVerified) {
          <div>
            {{ profession }}
          </div>
        }
      </div>
    }
    @if (!hideWorkspace) {
      <div class="subtitle-text">
        @if (workspaces && workspaces.length) {
          <div>
            <div>
              @for (company of workspaces; track company; let i = $index) {
                <div
                  [ngClass]="{ light: companyInFocusId !== company.companyId }"
                >
                  @if (
                    (company.isActive !== false && showAllWorkspaces) ||
                    companyInFocusId === company.companyId
                  ) {
                    <div class="celo-elipsis fw">
                      @if (onlyShowPosition) {
                        {{ company.position?.trim() || "" }}
                      } @else {
                        {{
                          company.position &&
                          (company.position | isValidString) &&
                          showPosition
                            ? company.position + ", "
                            : ""
                        }}{{
                          company.departmentName && showDepartment
                            ? company.departmentName
                            : "No Department"
                        }}{{
                          company.companyName && showCompany
                            ? ", " + company.companyName
                            : ", No company name"
                        }}
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (replaceWorkspace) {
      <div class="subtitle-text light">
        {{ replaceWorkspace }}
      </div>
    }
  </div>
  <div class="info">
    <div class="content">
      @if (isAdmin) {
        <div class="admin">Admin</div>
      }
    </div>
  </div>
</div>
